

<div class="divPanelBox" id="divempgraph">
  <highcharts-chart [Highcharts]="highchartsColEmpGraph"
                    [options]="chartOptionsColEmpGraph"
                    style="width: 100%; height: 400px; display: block;">
  </highcharts-chart>
</div>



<div class="modal" id="myModalChartTrans" [style.display]="showChartTransModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" id="divChartTransCT">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" id="divChartTransTitle"></h4>
        <button type="button" class="close" data-dismiss="modal" (click)="HideChartTransData()">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <!--<app-emp-graph-trans #empgraphtrans></app-emp-graph-trans>-->
      </div>

    </div>
  </div>
</div>
